// Opens external http/https links in a new tab so they do not navigate the
// current page — or the theme-editor preview iframe — when clicked.
class SRichtext extends HTMLElement {
  connectedCallback() {
    for (const link of this.querySelectorAll('a[href]')) {
      try {
        const url = new URL(link.href, window.location.href);
        if (
          (url.protocol === 'https:' || url.protocol === 'http:') &&
          url.origin !== window.location.origin
        ) {
          link.setAttribute('target', '_blank');
          link.setAttribute('rel', 'noopener noreferrer');
        }
      } catch {
        // Skip links with malformed href values
      }
    }
  }
}

customElements.define('s-richtext', SRichtext);
